<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Retraites et recollections" />
            <LesRecollections />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'

import FooterComp from '../Layouts/FooterComp'
import LesRecollections from './LesRecollections.vue';


export default {
    name: 'ConferenceAvantPage',
    components: {
        NavBar,
        PageTitle,
        LesRecollections,
        FooterComp,
    }
}
</script>